import Input from "tds/input";

export { Input };

customElements.define("tds-input", Input.CustomElementConstructor);
